var _path, _circle, _circle2, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67932 11.1311L1.67932 12.9655C1.67932 13.2434 1.90464 13.4687 2.18257 13.4687L2.57431 13.4687M8.32769 5.59424H11.869C11.9316 5.59424 11.9877 5.63288 12.01 5.69138L13.3 9.07175C13.3201 9.12437 13.3669 9.16213 13.4226 9.1706L15.0195 9.4135C15.3391 9.46211 15.5753 9.73693 15.5753 10.0602V13.3084C15.5753 13.3948 15.5053 13.4648 15.4189 13.4648L14.7897 13.4648M7.19834 13.4685L10.1575 13.4685",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.87433,
    cy: 13.5452,
    r: 1.36799,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4728,
    cy: 13.5462,
    r: 1.36799,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3378 9.13862H10.572C10.4383 9.13862 10.33 9.03027 10.33 8.89661V6.99072",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.86719,
    cy: 7.03446,
    rx: 3.44239,
    ry: 3.44071,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00434 4.26562C4.21278 4.26562 4.38175 4.4346 4.38175 4.64303V6.95614C4.51325 7.06332 4.59724 7.22657 4.59724 7.40944C4.59724 7.68812 4.40221 7.92124 4.14119 7.97977L3.05568 9.03244C2.90604 9.17754 2.66711 9.17387 2.522 9.02424C2.37689 8.8746 2.38057 8.63567 2.5302 8.49056L3.45722 7.5916C3.43843 7.53428 3.42827 7.47305 3.42827 7.40944C3.42827 7.2345 3.50513 7.07751 3.62693 6.97039V4.64303C3.62693 4.4346 3.7959 4.26562 4.00434 4.26562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOutline);
export default __webpack_public_path__ + "static/media/work-outline.c5f30e868863929b5d31b83befb7781c.svg";
export { ForwardRef as ReactComponent };